export default "__VITE_ASSET__Bs4y2eJ1__"